export default "__VITE_ASSET__sPqWaO8x__"